import { render, staticRenderFns } from "./RewardsProgramModal.vue?vue&type=template&id=2370bd5c&scoped=true&"
import script from "./RewardsProgramModal.vue?vue&type=script&lang=ts&"
export * from "./RewardsProgramModal.vue?vue&type=script&lang=ts&"
import style0 from "./RewardsProgramModal.vue?vue&type=style&index=0&id=2370bd5c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2370bd5c",
  null
  
)

export default component.exports